import { GenNonDuplicateID } from '@/utils/tools'
import { pictureArr, precisionsObj, titlelist, unitObj } from '@/views/erp/enums'
import { fieldTypeConfig } from '@/enums/preObjectManage'
import { dealFormConfig } from '@/utils/preObjectManage/utils'
import { isNullOrUnDef } from '@/utils/is'

interface ListItem {
  affiliationType: string
  subField: 0 | 1
  subs: Recordable[]
}

export function useSubTable() {
  // 要显示的布局的数据容器
  const positionsList = ref<Recordable[]>([])
  const formDataList = ref<Recordable>({}) // 子表
  async function formatFieldConfig(list: ListItem[], intId: string, subTableApi: Fn) {
    positionsList.value = list.filter(item => item.subField === 1)
    positionsList.value.map(async (module: Recordable) => {
      module.tID = GenNonDuplicateID(3)
      // 根据affiliationType获取对应的subType
      titlelist.forEach(data => {
        if (module.affiliationType === data.label) {
          module.subType = data.value
        }
      })
      // 只处理子表的显示和隐藏
      module.show = true
      // 子表数据写入
      module.tableData = (await subTableApi({ id: intId, type: module.subType })) || []
      module.subs = module.subs.map((item: Recordable) => {
        if (item.field) {
          formDataList.value[item.field] =
            item.type === fieldTypeConfig.picture || item.type === fieldTypeConfig.enclosure
              ? []
              : ''
        }

        if (item.type === fieldTypeConfig.picture || item.type === fieldTypeConfig.enclosure) {
          module.tableData.forEach((row: Recordable) => {
            if (row[item.field] && typeof row[item.field] === 'string')
              try {
                row[item.field] = JSON.parse(row[item.field])
              } catch (e) {
                console.log(e)
              }
          })
        }

        const strategyFn =
          dealFormConfig[item.type] || dealFormConfig[fieldTypeConfig.singleLineText] // 默认值为单行文本
        const config = { ...item }
        //  下拉option： columnDataList
        if (item.type === fieldTypeConfig.select) config.columnDataList = JSON.parse(item.options)
        //  上传 columnOperateList
        if (item.type === fieldTypeConfig.picture || item.type === fieldTypeConfig.enclosure) {
          if (pictureArr.includes(item.field)) {
            config.columnOperateList = [{ code: 'COLUMN:PICTURE_ONE', value: true }]
          }
        }

        // 要改
        if (item.type === fieldTypeConfig.address) {
          config.columnOperateList = [{ code: 'COLUMN:PICTURE_ONE', value: true }]
        }

        if (isNullOrUnDef(config.precisions)) {
          // 根据不同的字段确确定精度,单位
          config.precisions = getPrecisionsByName(item)
          config.unit = getUnitByName(item)
        }
        const renderConfig = strategyFn({ ...config }, { tableColumnType: 10 })

        if (item.type === fieldTypeConfig.picture) {
          renderConfig.compName = 'w-uploadImgIncome'
        }
        const customField = {
          ...config,
          renderConfig,
          columnInfo: { ...config }
        }
        // 上传为[]
        // const value = (item.type === fieldTypeConfig.picture || item.type === fieldTypeConfig.enclosure) ? [] : ''
        return {
          show: true,
          isTxt: true,
          customField,
          columnInfo: { ...config },
          defaultValue: unref(formDataList)[item.field],
          ...config,
          fieldCode: item.field
        }
      })
      return {
        ...module
      }
    })
  }

  // 根据不同的字段确确定精度
  function getPrecisionsByName(item: Recordable) {
    return precisionsObj[item.field]
  }

  // 根据不同的字段确确定单位
  function getUnitByName(item: Recordable) {
    return unitObj[item.field]
  }

  return {
    formatFieldConfig,
    positionsList
  }
}

export function getDisabled(permissions: Recordable, key: string) {
  if (permissions[key] instanceof Array) {
    return !permissions[key].includes('WRITE')
  }
  return true
}
